function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5 7.08333C8.12428 7.08333 7.76394 7.23259 7.49827 7.49827C7.23259 7.76394 7.08333 8.12428 7.08333 8.5V28.3333C7.08333 28.7091 7.23259 29.0694 7.49827 29.3351C7.76394 29.6007 8.12428 29.75 8.5 29.75H25.5C25.8757 29.75 26.2361 29.6007 26.5017 29.3351C26.7674 29.0694 26.9167 28.7091 26.9167 28.3333V8.5C26.9167 8.12428 26.7674 7.76394 26.5017 7.49827C26.2361 7.23259 25.8757 7.08333 25.5 7.08333H22.6667C21.8843 7.08333 21.25 6.44907 21.25 5.66667C21.25 4.88426 21.8843 4.25 22.6667 4.25H25.5C26.6272 4.25 27.7082 4.69777 28.5052 5.4948C29.3022 6.29183 29.75 7.37283 29.75 8.5V28.3333C29.75 29.4605 29.3022 30.5415 28.5052 31.3385C27.7082 32.1356 26.6272 32.5833 25.5 32.5833H8.5C7.37283 32.5833 6.29183 32.1356 5.4948 31.3385C4.69777 30.5415 4.25 29.4605 4.25 28.3333V8.5C4.25 7.37283 4.69777 6.29183 5.4948 5.4948C6.29183 4.69777 7.37283 4.25 8.5 4.25H11.3333C12.1157 4.25 12.75 4.88426 12.75 5.66667C12.75 6.44907 12.1157 7.08333 11.3333 7.08333H8.5Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.91797 4.2513C9.91797 2.6865 11.1865 1.41797 12.7513 1.41797H21.2513C22.8161 1.41797 24.0846 2.6865 24.0846 4.2513V7.08463C24.0846 8.64944 22.8161 9.91797 21.2513 9.91797H12.7513C11.1865 9.91797 9.91797 8.64944 9.91797 7.08463V4.2513ZM21.2513 4.2513H12.7513V7.08463H21.2513V4.2513Z"
});

var SvgClipboard = function SvgClipboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "#B2BCC6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clipboard.de2b0151.svg";
export { ForwardRef as ReactComponent };